import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Trophy, Mail, Lock, LogIn } from 'lucide-react';
import { useAuth, formatApiError } from '../../context/AuthContext';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || '/fantasy';

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-emerald-950 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-400/30 mb-4">
            <Trophy className="w-8 h-8 text-emerald-400" />
          </div>
          <h1 className="text-3xl font-bold text-white">RatingPro Fantasy</h1>
          <p className="text-emerald-300/80 text-sm mt-1 italic">O Manager Oficial da Nossa Pelada</p>
          <p className="text-emerald-200/70 mt-2">Entra na tua conta de Treinador</p>
        </div>

        <form onSubmit={onSubmit} className="bg-slate-900/60 backdrop-blur border border-white/10 rounded-2xl p-6 shadow-2xl space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm text-slate-300 font-medium">Email</label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="email" required autoFocus
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-slate-800/70 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="tu@email.pt"
                data-testid="login-email-input"
              />
            </div>
          </div>

          <div>
            <label className="text-sm text-slate-300 font-medium">Senha</label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-slate-800/70 border border-white/10 rounded-lg pl-10 pr-3 py-2.5 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>
          </div>

          {err && <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="login-error">{err}</div>}

          <button
            type="submit" disabled={loading}
            className="w-full bg-emerald-500 hover:bg-emerald-400 disabled:opacity-50 disabled:cursor-not-allowed text-slate-900 font-semibold rounded-lg py-2.5 flex items-center justify-center gap-2 transition-colors"
            data-testid="login-submit-btn"
          >
            <LogIn className="w-4 h-4" />
            {loading ? 'A entrar...' : 'Entrar'}
          </button>

          <div className="text-center text-sm text-slate-400 pt-2">
            Ainda não tens conta?{' '}
            <Link to="/register" className="text-emerald-400 hover:text-emerald-300 font-medium" data-testid="login-register-link">
              Regista-te
            </Link>
          </div>
        </form>

        <div className="text-center mt-6">
          <Link to="/" className="text-slate-400 hover:text-white text-sm">← Voltar ao site</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
